<template>
  <ClientOnly>
    <div class="mouse-scrolling max-ml:hidden">
      <div class="mouse-box">
        <div class="mouse"></div>
      </div>
      <p class="copy-writing">滑动查看更多</p>
    </div>
  </ClientOnly>
</template>
<script setup></script>
<style lang="scss" scoped>
@keyframes fadeIn {
  to {
    opacity: 1;
  }
}

.mouse-scrolling {
  position: fixed;
  z-index: 9999;
  top: 50%;
  left: 0;
  animation: fadeIn 2s ease-in forwards;
  animation-delay: 1s;

  /* 3秒后开始动画 */
  opacity: 0;

  .copy-writing {
    padding-left: 14px;
    margin-top: 50px;
    animation: colorText 5s ease-out infinite, nudgeText 5s ease-out infinite;
    color: #fff;
    font-size: 16px;
    letter-spacing: 12px;
    text-indent: 12px;
    text-orientation: upright;
    writing-mode: vertical-rl;
  }

  .mouse-box {
    transform: scale(0.4);
  }

  .mouse {
    position: relative;
    width: 52px;
    height: 88px;
    border-radius: 100px;
    animation: colorSlide 6s linear infinite, nudgeMouse 6s ease-out infinite;
    background:
      #4e5559 linear-gradient(
        transparent 0%,
        transparent 50%,
        #fff 50%,
        #fff 100%
      );
    background-size: 100% 100%;
    background-size: 225%;
  }

  .mouse::before,
  .mouse::after {
    position: absolute;
    margin: auto;
    content: "";
    inset: 0;
  }

  .mouse::before {
    width: 46px;
    height: 82px;
    border-radius: 100px;
    background-color: #222a30;
  }

  .mouse::after {
    width: 10px;
    height: 10px;
    border-radius: 100%;
    animation: trackBallSlide 5s linear infinite;
    background-color: #fff;
  }

  @keyframes colorSlide {
    0% {
      background-position: 0% 100%;
    }

    20% {
      background-position: 0% 0%;
    }

    21% {
      background-color: #4e5559;
    }

    29.99% {
      background-color: #fff;
      background-position: 0% 0%;
    }

    30% {
      background-color: #4e5559;
      background-position: 0% 100%;
    }

    50% {
      background-position: 0% 0%;
    }

    51% {
      background-color: #4e5559;
    }

    59.99% {
      background-color: #fff;
      background-position: 0% 0%;
    }

    60% {
      background-color: #4e5559;
      background-position: 0% 100%;
    }

    80% {
      background-position: 0% 0%;
    }

    81% {
      background-color: #4e5559;
    }

    89.99%,
    100% {
      background-color: #fff;
    }
  }

  @keyframes colorSlide {
    0% {
      background-position: 0% 100%;
    }

    20% {
      background-position: 0% 0%;
    }

    21% {
      background-color: #4e5559;
    }

    29.99% {
      background-color: #fff;
      background-position: 0% 0%;
    }

    30% {
      background-color: #4e5559;
      background-position: 0% 100%;
    }

    50% {
      background-position: 0% 0%;
    }

    51% {
      background-color: #4e5559;
    }

    59.99% {
      background-color: #fff;
      background-position: 0% 0%;
    }

    60% {
      background-color: #4e5559;
      background-position: 0% 100%;
    }

    80% {
      background-position: 0% 0%;
    }

    81% {
      background-color: #4e5559;
    }

    89.99%,
    100% {
      background-color: #fff;
    }
  }

  @keyframes trackBallSlide {
    0% {
      opacity: 1;
      transform: scale(1) translateY(-20px);
    }

    6% {
      opacity: 1;
      transform: scale(0.9) translateY(5px);
    }

    14% {
      opacity: 0;
      transform: scale(0.4) translateY(40px);
    }

    15%,
    19% {
      opacity: 0;
      transform: scale(0.4) translateY(-20px);
    }

    28%,
    29.99% {
      opacity: 1;
      transform: scale(1) translateY(-20px);
    }

    30% {
      opacity: 1;
      transform: scale(1) translateY(-20px);
    }

    36% {
      opacity: 1;
      transform: scale(0.9) translateY(5px);
    }

    44% {
      opacity: 0;
      transform: scale(0.4) translateY(40px);
    }

    45%,
    49% {
      opacity: 0;
      transform: scale(0.4) translateY(-20px);
    }

    58%,
    59.99% {
      opacity: 1;
      transform: scale(1) translateY(-20px);
    }

    60% {
      opacity: 1;
      transform: scale(1) translateY(-20px);
    }

    66% {
      opacity: 1;
      transform: scale(0.9) translateY(5px);
    }

    74% {
      opacity: 0;
      transform: scale(0.4) translateY(40px);
    }

    75%,
    79% {
      opacity: 0;
      transform: scale(0.4) translateY(-20px);
    }

    88%,
    100% {
      opacity: 1;
      transform: scale(1) translateY(-20px);
    }
  }

  @keyframes trackBallSlide {
    0% {
      opacity: 1;
      transform: scale(1) translateY(-20px);
    }

    6% {
      opacity: 1;
      transform: scale(0.9) translateY(5px);
    }

    14% {
      opacity: 0;
      transform: scale(0.4) translateY(40px);
    }

    15%,
    19% {
      opacity: 0;
      transform: scale(0.4) translateY(-20px);
    }

    28%,
    29.99% {
      opacity: 1;
      transform: scale(1) translateY(-20px);
    }

    30% {
      opacity: 1;
      transform: scale(1) translateY(-20px);
    }

    36% {
      opacity: 1;
      transform: scale(0.9) translateY(5px);
    }

    44% {
      opacity: 0;
      transform: scale(0.4) translateY(40px);
    }

    45%,
    49% {
      opacity: 0;
      transform: scale(0.4) translateY(-20px);
    }

    58%,
    59.99% {
      opacity: 1;
      transform: scale(1) translateY(-20px);
    }

    60% {
      opacity: 1;
      transform: scale(1) translateY(-20px);
    }

    66% {
      opacity: 1;
      transform: scale(0.9) translateY(5px);
    }

    74% {
      opacity: 0;
      transform: scale(0.4) translateY(40px);
    }

    75%,
    79% {
      opacity: 0;
      transform: scale(0.4) translateY(-20px);
    }

    88%,
    100% {
      opacity: 1;
      transform: scale(1) translateY(-20px);
    }
  }

  @keyframes nudgeMouse {
    0% {
      transform: translateY(0);
    }

    20% {
      transform: translateY(8px);
    }

    30% {
      transform: translateY(0);
    }

    50% {
      transform: translateY(8px);
    }

    60% {
      transform: translateY(0);
    }

    80% {
      transform: translateY(8px);
    }

    90% {
      transform: translateY(0);
    }
  }

  @keyframes nudgeMouse {
    0% {
      transform: translateY(0);
    }

    20% {
      transform: translateY(8px);
    }

    30% {
      transform: translateY(0);
    }

    50% {
      transform: translateY(8px);
    }

    60% {
      transform: translateY(0);
    }

    80% {
      transform: translateY(8px);
    }

    90% {
      transform: translateY(0);
    }
  }

  @keyframes nudgeText {
    0% {
      transform: translateY(0);
    }

    20% {
      transform: translateY(2px);
    }

    30% {
      transform: translateY(0);
    }

    50% {
      transform: translateY(2px);
    }

    60% {
      transform: translateY(0);
    }

    80% {
      transform: translateY(2px);
    }

    90% {
      transform: translateY(0);
    }
  }

  @keyframes nudgeText {
    0% {
      transform: translateY(0);
    }

    20% {
      transform: translateY(2px);
    }

    30% {
      transform: translateY(0);
    }

    50% {
      transform: translateY(2px);
    }

    60% {
      transform: translateY(0);
    }

    80% {
      transform: translateY(2px);
    }

    90% {
      transform: translateY(0);
    }
  }

  @keyframes colorText {
    21% {
      color: #4e5559;
    }

    30% {
      color: #fff;
    }

    51% {
      color: #4e5559;
    }

    60% {
      color: #fff;
    }

    81% {
      color: #4e5559;
    }

    90% {
      color: #fff;
    }
  }

  @keyframes colorText {
    21% {
      color: #4e5559;
    }

    30% {
      color: #fff;
    }

    51% {
      color: #4e5559;
    }

    60% {
      color: #fff;
    }

    81% {
      color: #4e5559;
    }

    90% {
      color: #fff;
    }
  }
}
</style>
